import { render } from "./Modal.vue?vue&type=template&id=11b4a13d&scoped=true"
const script = {}

import "./Modal.vue?vue&type=style&index=0&id=11b4a13d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11b4a13d"

export default script